export const ISSFloridaStatus = ({ isOverFlorida, isNearby }) => (
  <div className={`rounded-xl p-6 mb-6 border ${
    isOverFlorida 
      ? "bg-emerald-500/10 border-emerald-500/30" 
      : isNearby 
        ? "bg-amber-500/10 border-amber-500/30"
        : "bg-white/5 border-white/10"
  }`}>
    <h3 className="font-heading font-bold text-lg text-white mb-2">
      {isOverFlorida 
        ? "ISS is over Florida now!" 
        : isNearby 
          ? "ISS is nearby Florida"
          : "ISS is not currently visible from Florida"}
    </h3>
    <p className="text-sm text-slate-400">
      {isOverFlorida 
        ? "Head outside now for a chance to see the International Space Station!"
        : isNearby
          ? "The ISS may become visible from Florida soon. Check NASA's Spot the Station for pass times."
          : "Use NASA's Spot the Station to find upcoming visible passes over your location."}
    </p>
  </div>
);
